// Copyright (c) 2017 Deere & Company

import ClaimDebit from './claim-debit';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.claimDebit
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDebit);



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/components/index.js